<!--
  Consent banner — one compact row.
  
  It was three stacked blocks (checkbox line, link line, button line) which pushed the document
  down the page and read as a form to fill in rather than a single confirmation. @kurtulus called
  it cumbersome. It is now one line on desktop: checkbox and sentence on the left, the disclosure
  link inline at the end of that sentence, and the action on the right.

  The checkbox sentence and the disclosure link text are DATA from the disclosure row — part of
  the consent, never an i18n key or a hard-coded string, or the text a signer accepted would
  differ from the version recorded. Only the button label is translated.
-->
<div class="disclosure-banner" role="region" [attr.aria-label]="disclosureTitle">
  <label class="disclosure-check">
    <input type="checkbox"
           name="disclosureConsent"
           [(ngModel)]="checked"
           [disabled]="submitting"
           data-testid="disclosure-checkbox">
    <span class="disclosure-consent-text">{{ consentText }}<!--
   --><a href="#"
          class="disclosure-link"
          (click)="onOpen($event)"
          data-testid="disclosure-open">{{ disclosureTitle }}</a>
    </span>
  </label>

  <button type="button"
          class="btn btn-primary btn-sm disclosure-accept"
          [disabled]="!canAccept"
          (click)="onAccept()"
          data-testid="disclosure-accept">
    <span translate>Accept &amp; Continue</span>
  </button>
</div>
